export default __webpack_public_path__ + "static/media/iconmonstr-link-1.0d84a6c9.svg";